/**
 * Stav podnetu
 */
export enum InsuranceSubmissionState {
  /**
   * Nový
   */
  NEW = 'NEW',

  /**
   * Spracovaný
   */
  PROCESSED = 'PROCESSED',
}
